import React from 'react'
import smartSearchIcon from '../../assets/images/smart_search_icon.png'

const GenerateButton = ({
    className = '',
    disableGenerateButton = false,
    ...props
}) => {
    return (
        <button
            aria-label='Generate inspiration'
            type='button'
            disabled={disableGenerateButton}
            className={`w-[207px] h-[48px] px-[16px] py-[12px] bg-pink-primary text-white rounded-[12px] font-[500]  ${className} ${disableGenerateButton ? "cursor-not-allowed opacity-[60%]" : "cursor-pointer"}`}
            {...props}
        >
            <div className='w-[175px] h-[24px] flex items-center justify-center gap-[8px]'>
                <img className='h-[16px] w-[16px]' src={smartSearchIcon} alt="" />
                <span className='w-[151px] text-[16px] tracking-[-0.02em]'>
                    Generate inspiration
                </span>
            </div>
        </button>
    )
}

export default GenerateButton